// extracted by mini-css-extract-plugin
export default {"EmbeddedWrapper":"EmbeddedVideoPlayer_EmbeddedWrapper__PNWw5"};